module.exports = __webpack_public_path__ + "static/img/1048@2x.321b685e.png";